import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { color, font, layout } from "../../theme/tokens";

export const SideBarContainer = styled.div`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: ${color.paper};
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: ${({ $isopen }) => ($isopen ? "1" : "0")};
  transform: ${({ $isopen }) => ($isopen ? "translateY(0)" : "translateY(-100%)")};
  /* Keep the panel out of the tab order and off the pointer when closed. */
  visibility: ${({ $isopen }) => ($isopen ? "visible" : "hidden")};
  /* Guard: nothing inside this fixed panel should ever widen the document. */
  overflow: hidden;
`;

export const CloseIcon = styled(FaTimes)`
  color: ${color.inkStrong};
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.15rem;
  right: ${layout.gutterMobile};
  background: transparent;
  font-size: 1.6rem;
  cursor: pointer;
  outline: none;
`;

export const SideBarMenu = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SideBarWrapper = styled.div`
  width: 100%;
  padding: 0 ${layout.gutterMobile};
`;

export const SideBarLink = styled(LinkR)`
  display: block;
  font-family: ${font.display};
  font-size: 2.5rem;
  font-weight: 400;
  letter-spacing: -0.015em;
  text-decoration: none;
  color: ${color.green};
  cursor: pointer;
  padding: 12px 0;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${color.clay};
  }

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const SideBarFooter = styled.div`
  position: absolute;
  bottom: ${layout.gutterMobile};
  left: ${layout.gutterMobile};
  right: ${layout.gutterMobile};

  a {
    /* Pad the link out to a 44px touch target. */
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    font-family: ${font.body};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: ${color.inkMuted};
    text-decoration: none;
    max-width: 100%;

    /* The address is one unbreakable string; at 320px the tracking pushes it
       past the viewport. */
    @media screen and (max-width: 380px) {
      font-size: 10px;
      letter-spacing: 0.08em;
    }
  }
`;
